<template>
  <BLayoutView
    :back-route="backRoute"
    title="Просмотр всех действий с процедурой"
    :save-menu-list="null"
  >
    <Table
      :list="list"
      :pagination="pagination"
      :server-items-length="pagination.count"
      :loading="isLoading"
      class="mt-3"
      @change:pagination="onChangePagination"
    />
  </BLayoutView>
</template>

<script>
import BLayoutView from '@/components/layouts/BLayoutView.vue'
import Table from './components/Journal/UserActionHistory/Table.vue'

import { EventLogApi } from '@/api/resources/Marks'
import { MARKS_ROUTES as ROUTES } from './utils'

export default {
  name: 'MarksJournalActionsView',
  components: {
    Table,
    BLayoutView,
  },
  data: () => ({
    list: [],
    backRoute: { name: ROUTES.LIST },
    isLoading: false,
    pagination: {
      page: 1,
      per_page: 10,
      count: 0,
    },
  }),
  created() {
    this.onGetData()
  },
  methods: {
    async onGetData(params = this.pagination) {
      const { page, per_page: pageSize } = params
      const api = new EventLogApi()
      this.isLoading = true
      const { procedure_id } = this.$route.query
      try {
        const { data, meta } = await api.getUserActionHistory(procedure_id, {
          page,
          pageSize,
        })
        if (Array.isArray(data)) {
          this.list = data
        }
        if (meta) {
          this.pagination.count = meta.count || 0
          this.pagination.page = meta.page || this.pagination.page || 1
          this.pagination.per_page = meta.page_size || this.pagination.per_page || 10
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    onChangePagination(options) {
      const params = {
        ...this.pagination,
        ...options,
      }

      return this.onGetData(params)
    },
  },
}
</script>
